import { createFileRoute } from '@tanstack/react-router'
import { EmployeesPage } from '../../../../features/hr/employees-page'
import { employeeSearchSchema } from '../../../../features/hr/search'

export const Route = createFileRoute('/_app/hr/employees/')({
  validateSearch: employeeSearchSchema,
  component: EmployeesPage,
})
